import { useQuery } from "react-query";
import { PagedList, getPagedItems, create, getItems } from "../Api";
import { EQuoteDeductionCategory } from "../Quote/EQuoteDeductionCategory";
import { EQuoteDeductionStatus } from "../Quote/EQuoteDeductionStatus";
import { Quote } from "../Quote/Quote";
import { QuoteDeduction } from "../Quote/QuoteDeduction";
import { Deduction } from "./Deduction";
import { DeductionQueryParams } from "./DeductionQueryParams";
import { EDeductionType } from "./EDeductionType";

export async function getDeductions(queryParams: DeductionQueryParams): Promise<PagedList<Deduction>> {
  const { page, pageSize, searchQuery, category, status } = queryParams;

  var queryString = "";

  if (searchQuery) {
    queryString += `&query=${searchQuery}`;
  }

  var filters = [];

  if (category) {
    filters.push({
      field: "category",
      value: category
    });
  }

  if (status) {
    filters.push({
      field: "status",
      value: status
    });
  }

  if (filters.length > 0) {
    filters.forEach((item, i) => {
      queryString += `&filters[${i}].field=${item.field}&filters[${i}].value=${item.value}`;
    });
  }

  return getPagedItems<Deduction>("Pricing/Deduction", page, pageSize, queryString);
}

//todo remove quotededuction
export async function addDeductionToQuote(quote: Quote, deduction: Deduction, discountValue?: number) {
  return create<QuoteDeduction, QuoteDeduction>(`Store/Quote/${quote.id}/Deduction`, {
    id: deduction.id,
    code: deduction.code,
    promoCode: deduction.promoCode,
    name: deduction.name,
    description: deduction.description,
    category: EQuoteDeductionCategory.Discount,
    type: EDeductionType.Number,
    value: discountValue || deduction.value,
    isCustomer: false,
    isCustomValue: false,
    status: EQuoteDeductionStatus.Added
  });
}

export async function getQuoteAvailableDeductions(quoteId: string): Promise<Deduction[]> {
  return getItems<Deduction>(`store/quotediscount/${quoteId}/available`);
}

const QuoteAvailableDeductions = "quote-available-deductions";

export const useQuoteAvailableDeductions = (quoteId: string) =>
  useQuery([QuoteAvailableDeductions, quoteId], () => getQuoteAvailableDeductions(quoteId), {
    enabled: false
  });
